import React from "react";
import "./templateTwo.css";
import { Box } from "@chakra-ui/react";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { convertAmountToWords } from "components/allForm/PaymentMode/helper";
import TermsAndConditions from "./commonComponent/termsAndConditions";
import { Col, Row } from "react-bootstrap";
import useClientAddress from "../api/useClientAddress";
import BankDetails from "./commonComponent/bankDetails";
import { calculateItemGstAmount } from "../uttils/calculateItemGstAmount";
import BankDetailsWithProvidedData from "./commonComponent/bankDetailsWithDataProvided";

const ShowAddress = ({address, gst}) => {
  if (!address) return {};
  const city = address.cityName;
  const country = address.countryName;
  const state = address.stateName;
  return (
    <>
      <p className="fw-600">ATTN : {address?.atn}</p>
      <p>{address?.s1}</p>
      <p>{address?.s2}</p>
      <p>{city} {address?.pin}</p>
      <p>{state} {country}</p>

      <p className="mt-3"><strong>GSTIN</strong> <span className="mx-3">{gst || "NA"}</span></p>
      <p><strong>STATE</strong><span className="mx-3">{state}</span></p>
    </>
  )
}

const InvoiceTemplateTwo = ({
  title,
  idNo,
  invoice,
  invoiceDate,
  invoiceTerms,
  invoiceCurrency,
  invSub,
  itemList,
  currency,
  clientId,
  clientGst,
  gst,
  totalAmount,
  freightCharge,
  adjustment,
  customerNotes,
  totalPaymentAmount,
  dueDate,
  orgAddress,
  clientAddress,
  clientShippingAddress,
  clientDetail,
  logoUrl,
  organizationData,
  selectedBankDetails,
  isProforma
}) => {
  const {shipAdd, billAdd} = useClientAddress(clientDetail)
  return (
    <div id="Template2" className="template-two">
      {/* Header */}
      <div className="header">
        <div className="logo">
          <img src={logoUrl} alt="Logo" />
        </div>
        <div className="company-info">
          <p>{organizationData?.name}</p>
          <p>{orgAddress?.s1}</p>
          <p>{orgAddress?.s2}</p>
          <p>{orgAddress?.cityName}-{orgAddress?.pin}. {orgAddress?.stateName} – {orgAddress?.countryName}</p>
          <p className="web-link"><a href={organizationData?.web}>{organizationData?.web}</a></p>
        </div>
      </div>

      <div className="invoice-template">

      <table className="info-table">
        <tbody>
          <tr>
            <td className="invoice-title" colSpan="4"><p>{title}</p></td>
          </tr>
          <tr>
            <td colSpan="2" width="50%">
              <p className="fw-600">BILL TO : {clientDetail?.clName}</p>
              <ShowAddress address={clientAddress} gst={clientGst} />
            </td>
            <td colSpan="2" >
            <Row>
              <Col>
              <p><span className="fw-600 uppercase heading">{invoice?.heading}</span></p>
              <p><span className="fw-600 uppercase heading">{invoiceDate?.heading}</span></p>
              <p><span className="fw-600 uppercase heading">{invoiceTerms?.heading}</span></p>

              </Col>
              <Col>
              <p>{invoice?.value}</p>
            <p>{invoiceDate?.value}</p>
            <p>{invoiceTerms?.value}</p>

              </Col>
            </Row>

          
            </td>
          </tr>
          <tr>
            <td colSpan="2" width="50%" >
              <p className="fw-600">SHIP TO : {clientDetail?.clName}</p>
              <ShowAddress address={clientShippingAddress} gst={clientGst} />
            </td>
            <td colSpan="2">
            <Row>
              <Col>
              <p><span className="fw-600 uppercase heading">Due Date</span></p>
              <p><span className="fw-600 uppercase heading">Currency</span></p>

              </Col>
              <Col>
              <p>{dueDate?.value}</p>
              <p>{invoiceCurrency?.value}</p>

              </Col>
            </Row>

            </td>
          </tr>
          
          <tr>
            <td colSpan="4">Subject: {invSub?.value}</td>
          </tr>
        </tbody>
      </table>
      </div>
      <table className="package-table">
        <thead>
          <tr>
            <th width="30%">PACKAGE / CHECK TYPE</th>
            <th className="text-center">TYPE</th>
            <th className="text-center">QUANTITY</th>
            <th className="text-center">UNIT PRICE</th>
            <th className="text-center">TAX</th>
            {currency?.code === 'INR' &&<th className="text-center">{gst?.type === 'IGST' ? "IGST" :"CGST & SGST"}</th>}
            <th className="text-center">TOTAL</th>
          </tr>
        </thead>
        <tbody>
        {itemList &&
            itemList?.length &&
            itemList.map((item) => {
              const calTax = formatAmountIndianRupees(calculateItemGstAmount(item) || 0);

              return (
                <tr>
                <td>
                <p className="fw-600">{item?.slItm?.name}</p>
                <p style={{lineHeight:'1.3'}}>{item?.slItm?.dc}</p>
                <p>HSN/SAC - {item?.slItm?.hCd || item?.slItm?.sCd}</p>
                </td>
                <td className="text-center">{item?.slItm?.name}</td>
                <td className="text-center">{item?.qty}</td>
                <td className="text-center">{formatAmountIndianRupees(item?.prc)}</td>
                <td className="text-center">{item?.tax?.label || "-"}</td>
                {currency?.code === 'INR' &&<td className="text-center">{calTax}</td>}
                <td className="text-center">{formatAmountIndianRupees(item?.amt)}</td>
              </tr>
              );
            })}
            
        </tbody>
      </table>

      <Box className="summary-box" m={0} display="flex" justifyContent="space-between">
        <div className="p-2">
          <TermsAndConditions isProforma={isProforma} />
        </div>
      <table className="summary-table">
        <tbody>
          <tr>
          </tr>
          <tr>

            <td className="total-amt title" width="60%"><strong>TOTAL AMOUNT BEFORE TAX:</strong></td>
            <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(totalAmount || 0)}
            </td>
          </tr>
          {currency.code === "INR" ?
            <>
            <tr>
              <td className="heading title"><strong>I G S T</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(gst?.amount?.i || 0)}
              </td>
            </tr>
            <tr>
              <td className="heading title"><strong>S G S T</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(gst?.amount?.s || 0)}</td>
            </tr>
            <tr>
              <td className="heading title"><strong>C G S T</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(gst?.amount?.c || 0)}</td>
            </tr>
            </>
            :""
          }
          {freightCharge ?
           <tr>
              <td className="total-amt title"><strong>Freight Charges</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(freightCharge || 0)}s
              </td>
            </tr>
            :""
          }
           {adjustment?.value?
           <tr>
              <td className="total-amt title"><strong>{adjustment?.label}</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(adjustment?.value || 0)}s
              </td>
            </tr>
            :""
          }
           
            <tr>
              <td className="total-amt title"><strong>TOTAL AMOUNT WITH TAX</strong></td>
              <td className="text-end">{currency?.symbol || "₹"} {formatAmountIndianRupees(totalPaymentAmount)}
              </td>
            </tr>
            <tr>
              <td className="gst title"><strong>GST PAYABLE ON REVERSE CHARGE</strong></td>
              <td className="text-end">0.00</td>
            </tr>
          <tr>
            <td colSpan="2" className="title amount-word">{currency?.code} {convertAmountToWords(totalPaymentAmount || 0)}</td>
          </tr>
         
        </tbody>
      </table>
        
      </Box>
      <Box>
      <table className="footer-table">
        <thead>
          <tr>
            <td colSpan={3} className="heading"></td>
          </tr>
          <tr>
            <td colSpan={3} className=""></td>
          </tr>
          <tr>
            <th>REGI. OFFICE - {orgAddress?.cityName}</th>
            <th>Bank Details</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <p>{organizationData?.add?.s1}</p>
              <p>{organizationData?.add?.s2}</p>
              <p>{orgAddress?.cityName} - {organizationData?.add?.pin}</p>
              <p>{orgAddress?.stateName} {orgAddress?.countryName}</p></td>
            <td width="50%">
              {organizationData?.isBnk ?
                  <BankDetailsWithProvidedData bankDetails={selectedBankDetails} />
              :"NA"
              }
            </td>
          </tr>
          <tr>

            <td colSpan="4">
            <p className="contact">{isProforma ? organizationData?.pfFtxt :organizationData?.sFtxt}</p>
            </td>
          </tr>
        </tbody>
      </table>

      </Box>
      

      </div>
  );
};

export default InvoiceTemplateTwo;
